export default class TeaCornerEvent {
    /**
     * @param {string} type 
     */
    constructor(type, internalStakeholder) {
        this.type = type;
    }
}

TeaCornerEvent.ENABLE_TEA_CORNER_BUTTON = "TeaCornerEvent.ENABLE_TEA_CORNER_BUTTON";
TeaCornerEvent.DISABLE_TEA_CORNER_BUTTON = "TeaCornerEvent.DISABLE_TEA_CORNER_BUTTON";